import React, { useRef, useState } from "react";

import { Button, Popover, Typography } from "@mui/material";
import { useNumberFormatSelector } from "store";

import { FormContent } from "./FormContent";

export const NumberFormat: React.FC = () => {
  const { abbreviated, decimal } = useNumberFormatSelector();

  const [openAddPopover, setOpenAddPopover] = useState(false);
  const anchorEl = useRef<HTMLButtonElement | null>(null);

  const handleClose = () => {
    setOpenAddPopover(false);
  };

  return (
    <>
      <Button
        variant="outlined"
        color="secondary"
        sx={{
          borderColor: "#dae0e2",
          backgroundColor: "#fff",
          color: "#071f35",
          // Base 16px (the original Typography size), easing down on narrow viewports so it never wraps/clips.
          fontSize: { xs: "13px", sm: "14px", md: "16px" },
          p: "4px 10px",
          gap: "6px",
          flexShrink: 0,
          whiteSpace: "nowrap"
        }}
        ref={anchorEl}
        onClick={() => setOpenAddPopover(true)}
      >
        <Typography component="span" noWrap sx={{ fontSize: "inherit" }}>
          Number Format:
        </Typography>
        <Typography component="span" noWrap sx={{ fontSize: "inherit", fontWeight: "bold" }}>
          {!abbreviated ? "Full" : "B/M/T"}, {decimal}
        </Typography>
      </Button>
      <Popover
        sx={{
          ".MuiPopover-paper": {
            borderRadius: "8px"
          }
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left"
        }}
        open={openAddPopover}
        anchorEl={anchorEl.current}
        onClose={handleClose}
      >
        <FormContent close={handleClose} />
      </Popover>
    </>
  );
};
